<template>
  <div>
    <div class="wrapper d-flex flex-column min-vh-100">
      <!-- <PreTestSidebar /> -->
      <div class="body flex-grow-1 px-3">
        <CContainer lg>
          <div class="inner-container">
            <h1 class="header">JYG 企業 ESG 健檢</h1>
            <div class="d-flex justify-content-center">
              <img
                style="aspect-ratio: 1143 / 361; height: intrinsic"
                class="w-50 my-4"
                src="@/assets/icons/logo-full.jpeg"
              />
            </div>
            <PreTestForm @submit="finishPreTest" />
            <PreTestResult v-if="step === 2" :topic="topic" :score="score" />
          </div>
        </CContainer>
      </div>
    </div>
    <footer class="jyp_footer">
      <div class="jyp_footer__layout">
        <div class="jyp_footer__content">
          <div class="jyp_footer__block">
            <div class="jyp_footer__block-top">
              <div class="jyp_footer__follow">
                <div class="jyp_footer__follow__title">FOLLOW US</div>
                <div class="jyp_footer__follow__links">
                  <a
                    href="https://www.facebook.com/JYG-ESG-113683017038210"
                    target="_blank"
                    ><img
                      src="https://jygesg.com/assets/images/icons/facebook-square.png"
                  /></a>
                  <a
                    href="https://www.linkedin.com/company/jyg-esg"
                    target="_blank"
                    ><img
                      src="https://jygesg.com/assets/images/icons/linkedin.png"
                    />
                  </a>
                  <a href="https://lin.ee/XZXnT6e" target="_blank"
                    ><i class="fab fa-line"></i
                  ></a>
                </div>
              </div>
            </div>
            <div class="jyp_footer__block-bottom">
              <div class="jyp_footer__sitemap">
                <div class="title">網站地圖</div>
                <ul>
                  <li><a href="https://jygesg.com/">首頁</a></li>
                  <li>
                    <a href="https://jygesg.com/intro/aboutus">關於我們</a>
                  </li>
                  <li><a href="https://jygesg.com/service">JYG的見解</a></li>
                  <li><a href="https://jygesg.com/ESG">JYG ESG解決方案</a></li>
                  <li><a href="https://jygesg.com/press/">JYG活動與課程</a></li>
                  <li><a href="https://jygesg.com/contact">聯絡我們</a></li>
                </ul>
              </div>
            </div>
            <div class="copyright">
              © Copyright 2020. 金源誥 All Rights Reserved. Powered by YAii
              design
            </div>
          </div>
          <div class="jyp_footer__block">
            <div class="jyp_footer__logo">
              <img
                src="https://jygesg.com/assets/images/logo.png"
                alt="金源誥國際有限公司"
              />
            </div>
            <div class="contact__info">
              <div class="title">公司資訊:</div>
              <ul>
                <li>
                  <img
                    src="https://jygesg.com/assets/images/icons/ionic-md-time.png"
                  />
                  <div class="text">服務時間:週一至週五 09:00~18:00</div>
                </li>
                <li>
                  <img
                    src="https://jygesg.com/assets/images/icons/phone-alt.png"
                  />
                  <div class="text">
                    服務電話: <a href="tel:+886287713605">02-8771-3605</a>
                  </div>
                </li>
                <li>
                  <img src="https://jygesg.com/assets/images/icons/email.png" />
                  <div class="text">
                    電子郵件:<a href="mailto:info.jmr@msa.hinet.net"
                      >info.jmr@msa.hinet.net</a
                    >
                  </div>
                </li>
                <li>
                  <img
                    src="https://jygesg.com/assets/images/icons/location-on.png"
                  />
                  <div class="text">
                    <a
                      href="https://goo.gl/maps/Vp9iGRQzswxjbgAWA"
                      target="_blank"
                      >台北市大安區忠孝東路四段218之1號10樓</a
                    >
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import { CContainer } from '@coreui/vue'
import PreTestForm from './PreTestForm.vue'
import PreTestResult from './PreTestResult.vue'
// import PreTestSidebar from './PreTestSidebar.vue'
import { ref } from '@vue/reactivity'

export default {
  name: 'PreTest',
  components: {
    CContainer,
    PreTestForm,
    // PreTestSidebar,
    PreTestResult,
  },
  setup() {
    const step = ref(1)
    const score = ref(null)
    const topic = ref('')
    const finishPreTest = (payload) => {
      step.value = 2
      score.value = payload.score
      topic.value = payload.topic
    }

    return {
      step,
      score,
      topic,
      finishPreTest,
    }
  },
}
</script>

<style lang="scss" scoped>
.header {
  padding-top: 35px;
  padding-bottom: 40px;
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}
.inner-container {
  margin: 0 auto;
  max-width: 936px;
}

/* ======= jyp_footer ======= */
.jyp_footer {
  padding-top: 60px;
  padding-bottom: 40px;
  background-color: rgba(255, 147, 0, 0.05);
  font-weight: 300;
  a {
    color: #000;
    text-decoration: none;
    background-color: transparent;
  }
  a:hover {
    color: #000;
    text-decoration: none;
  }
  ul {
    padding-left: 0;
    margin-bottom: 0;
  }
  li {
    list-style: none;
  }
}
.jyp_footer__content {
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.jyp_footer__follow,
.jyp_footer__sitemap,
.jyp_footer__sitemap ul,
.contact__info li {
  display: -webkit-flex;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.jyp_footer__block {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}
.jyp_footer__block .title {
  font-size: 20px;
}
.jyp_footer__block-top {
  margin-bottom: 20px;
}
.jyp_footer__block-bottom {
  margin-top: auto;
}

/* jyp_footer follow */
.jyp_footer__follow__title {
  font-size: 20px;
  font-weight: 700;
  margin-right: 30px;
}

.jyp_footer__follow__links {
  display: flex;
  align-items: center;
}

.jyp_footer__follow__links a {
  display: inline-block;
  margin-right: 15px;
}

.jyp_footer__follow__links i {
  font-size: 37px;
}

.jyp_footer__sitemap {
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #000;
}
.jyp_footer__sitemap .title {
  margin-right: 40px;
}
.jyp_footer__sitemap a {
  display: inline-block;
  padding: 5px 15px;
}

.copyright {
  font-size: 12px;
  letter-spacing: 1px;
}
.jyp_footer__logo img {
  padding: 5px;
  height: 65px;
}
.contact__info .title {
  margin-top: 8px;
  margin-bottom: 15px;
}
.contact__info li {
  margin-bottom: 5px;
  letter-spacing: 1px;
}
.contact__info img {
  margin-right: 5px;
}

@media (max-width: 1211px) {
  .jyp_footer__content .jyp_footer__block {
    width: 100%;
  }
  .jyp_footer__content .jyp_footer__block:first-child {
    order: 2;
    margin-top: 20px;
  }
  .jyp_footer__block-top {
    order: 2;
  }
  .jyp_footer__block-bottom {
    order: 1;
  }
  .jyp_footer__sitemap {
    border-bottom: 0;
  }
  .jyp_footer__follow {
    justify-content: space-between;
    border-bottom: 1px solid #000;
    padding-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;
  }
  .jyp_footer__follow__title {
    font-size: 15px;
    margin-right: 0;
  }
  .jyp_footer__follow__links a {
    margin-left: 3px;
    margin-right: 3px;
  }
  .jyp_footer__follow__links img {
    width: 22px;
  }

  .jyp_footer .langs {
    margin-left: 0;
  }
  .copyright {
    order: 3;
    margin-top: 15px;
    padding-left: 15px;
    padding-right: 15px;
    text-align: center;
  }

  .jyp_footer__logo {
    text-align: center;
    margin-bottom: 20px;
  }
  .contact__info {
    margin-bottom: 20px;
  }
  .jyp_footer .contact__info ul {
    display: flex;
    flex-wrap: wrap;
  }
  .jyp_footer .contact__info li {
    width: 50%;
  }
  .contact__info .text {
    width: 92%;
    font-size: 14px;
  }
}
@media (max-width: 768px) {
  .jyp_footer__sitemap ul {
    margin-top: 15px;
  }
  .jyp_footer__sitemap a {
    padding: 5px 20px 5px 0;
  }
}

@media (max-width: 576px) {
  .jyp_footer .contact__info ul {
    display: block;
    flex-wrap: unset;
  }
  .jyp_footer .contact__info li {
    width: unset;
  }
  .jyp_footer__sitemap li {
    width: 50%;
  }
  .jyp_footer__sitemap a {
    display: block;
    padding: 2px 0;
  }
  .jyp_footer__follow__links i {
    position: relative;
    top: 1px;
    font-size: 25px;
  }
}

/* site floats */
.site-floats {
  position: fixed;
  top: 20%;
  right: 0;
  z-index: 999;
}

.site-floats .item {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #fff;
  background-color: rgb(255 101 0 / 90%);
  font-size: 16px;
  padding: 10px 20px;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  box-shadow: 0 0 30px 3px rgb(0 0 0 / 15%);
  transition: 0.3s;
}

.site-floats .item:hover {
  padding-right: 30px;
}

.site-floats img {
  width: 50px;
  margin-bottom: 10px;
}

@media (max-width: 576px) {
  .site-floats {
    top: 80%;
  }

  .site-floats .item {
    padding: 10px;
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  }

  .site-floats img {
    width: 40px;
  }
}

/* site-en */
.site-en {
  font-family: arial, 'Noto Sans TC', 'Microsoft JhengHei', 'å¾®è»Ÿæ­£é»‘é«”',
    sans-serif;
}

.site-en .site__nav-menu > li > a {
  letter-spacing: 0;
}

.jyp_footer__layout {
  margin-left: 8%;
  margin-right: 8%;
}
</style>
